import { Icon } from '@sunwebgroup/uds-ui/icon'
import { ListItem } from '@sunwebgroup/uds-ui/list-item'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { CMSRoomType } from '@/cms/fields/mappers/productDetailPageFieldsMapper'
import { RoomDetails } from '@/scopes/common/components/RoomDetails/RoomDetails'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics'
import styles from './RoomType.module.css'

interface RoomTypeProps {
  roomType: CMSRoomType
}

export function RoomType({ roomType }: RoomTypeProps) {
  const [isOpen, setIsOpen] = useState(false)
  const { sendEvent } = useAnalytics()
  const intl = useIntl()

  const images = roomType.imageUrls?.map(url => ({
    src: url,
    alt: roomType.name,
  })) || []

  const handleImageClick = (index: number) => {
    sendEvent(
      createPDPClickEvent({
        element: 'Slider',
        description: 'Roomtype images',
        result: `Open image ${index + 1}`,
        type: roomType.name,
      }),
    )
  }

  const handleOnSettleDetail = () => {
    sendEvent(
      createPDPClickEvent({
        element: 'Slider',
        description: 'Roomtype image Gallery',
        result: 'Slide',
        type: roomType.name,
      }),
    )
  }

  const handleIsOpen = (isOpen: boolean) => {
    setIsOpen(isOpen)

    if (isOpen) {
      sendEvent(
        createPDPClickEvent({
          element: 'Element clicked',
          description: 'Roomtype description',
          result: 'Open modal with more details',
          type: roomType.name,
        }),
      )
    }
    else {
      sendEvent(
        createPDPClickEvent({
          element: 'Element clicked',
          description: 'Roomtype description',
          result: 'Close modal with more details',
          type: roomType.name,
        }),
      )
    }
  }

  return (
    <>
      {(roomType.characteristics || !isEmpty(roomType.imageUrls)) && (
        <>
          <Sheet.Root open={isOpen} onOpenChange={handleIsOpen}>
            <Sheet.Trigger>
              <ListItem className={styles.roomType} variant="outlined" as="button" type="button">
                <div className={styles.description}>
                  <Icon glyph="TwoPeople" size={27} />
                  <div className={styles.nameAndCapacity}>
                    <Typography variant="body-l-bold-tight">{roomType.name}</Typography>
                    <Typography variant="body-m-regular-tight">{roomType.capacityText}</Typography>
                  </div>
                  {(roomType.characteristics || !isEmpty(roomType.imageUrls)) && <Icon className={styles.chevron} glyph="ChevronRight" size={16} />}
                </div>
              </ListItem>
            </Sheet.Trigger>
            <Sheet.Body side="right">
              <Sheet.Header titleLabel={intl.formatMessage({ id: 'roomtypes_room_description_heading' })} closeLabel={intl.formatMessage({ id: 'close' })} />
              <Sheet.Content className={styles.sheetContent}>
                <RoomDetails
                  name={roomType.name}
                  images={images}
                  characteristics={roomType.characteristics || []}
                  onImageClick={handleImageClick}
                  onGallerySettle={handleOnSettleDetail}
                />
              </Sheet.Content>
            </Sheet.Body>
          </Sheet.Root>
        </>
      )}
    </>
  )
}
